import axios from 'axios';

/**
 * Global axios yapılandırması.
 *
 * Tüm sayfalar `import axios from 'axios'` ile aynı varsayılan örneği paylaşır,
 * bu yüzden interceptor'ları burada bir kez kurmak yeterlidir.
 *
 * - İstek: localStorage'daki JWT'yi Authorization başlığına ekler.
 * - Yanıt: 401 alınırsa oturumu düşürüp /login'e yönlendirir.
 */

export const TOKEN_KEY = 'authToken';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearToken() {
  localStorage.removeItem(TOKEN_KEY);
}

axios.interceptors.request.use((config) => {
  const token = getToken();
  if (token) {
    config.headers = config.headers || {};
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      clearToken();
      // Zaten login sayfasındaysak tekrar yönlendirip döngü kurmayalım.
      if (window.location.pathname !== '/login') {
        window.location.replace('/login?expired=1');
      }
    }
    return Promise.reject(error);
  }
);
